import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import OwnerField from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/OwnerField'
import Category from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Category'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  onEmployeeIdChange: (employeeId: string | undefined) => void
  isAutomaticExpensable: boolean
  hasReportOnBehalfFeature: boolean
  canCreateExpensesForOthers: boolean
  canSeeEmployeeLegalEntity: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  onEffectiveOnChange: (value: string) => void
  divider?: boolean
  rightAction?: React.ReactNode
}

const ExpenseInformation = (props: Props) => {
  const {
    canSeeEmployeeLegalEntity,
    isAutomaticExpensable,
    currentEmployee,
    onEmployeeIdChange,
    hasReportOnBehalfFeature,
    canCreateExpensesForOthers,
    rightAction,
  } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.expense_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.expense_information_subtitle')}
      divider={props.divider}
      rightAction={rightAction}
    >
      <Box gap="s24">
        <OwnerField
          {...props}
          currentEmployee={currentEmployee}
          showEmployeeLegalEntity={canSeeEmployeeLegalEntity}
          isAutomaticExpensable={isAutomaticExpensable}
          onEmployeeIdChange={onEmployeeIdChange}
          hasReportOnBehalfFeature={hasReportOnBehalfFeature}
          canCreateExpensesForOthers={canCreateExpensesForOthers}
        />
        <Category {...props} />
      </Box>
    </FormBlock>
  )
}

export default ExpenseInformation
